module.exports = __webpack_public_path__ + "static/MobileBackground-ae773f8bf52623df0285bb5f3b601874.png";